import { render, staticRenderFns } from "./components_left2.vue?vue&type=template&id=046e18ad&scoped=true&"
import script from "./components_left2.vue?vue&type=script&lang=js&"
export * from "./components_left2.vue?vue&type=script&lang=js&"
import style0 from "./components_left2.vue?vue&type=style&index=0&id=046e18ad&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046e18ad",
  null
  
)

export default component.exports